var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPackages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 4.85a7.15 7.15 0 1 0 1.506 14.141.85.85 0 1 1 .356 1.663 8.85 8.85 0 1 1 5.964-12.79.85.85 0 0 1-1.502.796A7.15 7.15 0 0 0 10 4.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 11.85a3.65 3.65 0 1 0 0 7.3 3.65 3.65 0 0 0 0-7.3m-5.35 3.65a5.35 5.35 0 1 1 10.7 0 5.35 5.35 0 0 1-10.7 0"
}))));
export default SvgPackages;